import cookies from 'js-cookie'

// export function getOpenid() {
//   return 'opspY017O4UqjmQh_5xN-MXE8D_w'
// }

export function saveOpenid(openid) {
  cookies.set('openid', openid)
}

export function getOpenid() {
  return cookies.get('openid')
}

// export function removeOpenid() {
//   cookies.remove('openid')
// }

/**
 * 储存注册资源字段
 * @param {String} registerSource
 */
export function saveRegisterSource(registerSource) {
  sessionStorage.setItem('registerSource', registerSource)
}

/**
 * 获取注册资源字段
 * @param {String} registerSource
 * @return {String}
 */
export function getRegisterSource(registerSource) {
  return sessionStorage.getItem('registerSource', registerSource)
}

export function saveUserId(userId) {
  /** cookies改成session,在当前窗口有效 */
  sessionStorage.setItem('userId', userId)
}

export function getUserId() {
  /**
   * cookies改成session,在当前窗口有效
   * 1) js-cookies没有该值返回的是undefined,sessionStorage没有该值返回的是null
   * 2) 果没有值，返回和之前js-cookies一样的值，防止改成session影响了其他代码
   */
  let userId = sessionStorage.getItem('userId')
  if (userId == null) {
    return undefined
  } else {
    return userId
  }
}

export function removeUserId() {
  /** cookies改成session,在当前窗口有效 */
  sessionStorage.removeItem('userId')
}

export function saveJoinTraderId(joinTraderId) {
  /** cookies改成session,在当前窗口有效 */
  sessionStorage.setItem('joinTraderId', joinTraderId)
}

export function getJoinTraderId() {
  /**
   * cookies改成session,在当前窗口有效
   * 1) js-cookies没有该值返回的是undefined,sessionStorage没有该值返回的是null
   * 2) 如果没有值，返回和之前js-cookies一样的值，防止改成session影响了其他代码
   */
  let joinTraderId = sessionStorage.getItem('joinTraderId')
  if (joinTraderId == null) {
    return undefined
  } else {
    return joinTraderId
  }
}

export function removeJoinTraderId() {
  /** cookies改成session,在当前窗口有效 */
  sessionStorage.removeItem('joinTraderId')
}
//储存 判断IOS机型
export function setWeChatIos(type) {
  sessionStorage.setItem('wxchart', type)
}
//取出 判断IOS机型
export function getWeChatIos(type) {
  return sessionStorage.getItem('wxchart', type)
}

//储存 新春活动
export function saverecord(record) {
  cookies.set('record', record, {
    expires: 30 //设置 30天
  })
}
//储存 新春活动
export function getrecord() {
  return cookies.get('record')
}

//储存 人才培养信息
export function setTalentInfo(userInof) {
  localStorage.setItem('userInof', JSON.stringify(userInof))
}
//获取 人才培养信息
export function getTalentInfo() {
  return localStorage.getItem('userInof')
}

//删除 人才培养信息
export function removeTalentInfo() {
  return localStorage.removeItem('userInof')
}
//储存 个性化推荐
export function savepersonalise(personalise) {
  cookies.set('personalise', personalise)
}

export function getpersonalise() {
  return cookies.get('personalise')
}
